export default "<p>tablapescador works!</p>\n"